import React, { useEffect, useState } from 'react';



export const Clock = () => {
    
  const [date, setDate] = useState(new Date());
  
  function refreshClock() {
    setDate(new Date());
  }
  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);


  return (
    <h3 className='clock'>
      {date.toLocaleTimeString()}
    </h3>
  );
}
